<div class="custom-header" class="header-strip mobile-fix-header">
  <div class="motor-container-fluid">
    <div *ngIf="pageHeaderTxt === 'home' || pageHeaderTxt === 'editvehicle'"
      class="d-flex justify-content-between align-item-center">
      <div class="d-flex justify-content-between align-item-center " *ngIf="!bflJourney">
        <div class=" hide-mobile-xm page-title">
          <a href="https://www.bajajfinservmarkets.in/" class="header-anchor" target="_blank"><img
              class="head-logo-market" alt="MarktesLogo" width="95" height="20" src="assets/img/png/MarktesLogo.png"></a>
        </div>
        <div class="page-heading-txt" [ngClass]="bflJourney ? 'align-spc':''">
          <h3 class="insurance-head">{{VehicleType === 'FWGI' ? 'Private Car' : VehicleType === 'TWGI' ?
            'Two Wheeler':VehicleType === 'TXGI' ? 'Taxi' : VehicleType === 'CVGI' ?'Commercial Vehicle' :''}}
            Insurance</h3>
        </div>
      </div>
      <div class="d-flex justify-content-between align-item-center " *ngIf="bflJourney">
        <div class="page-title">
          <a href="https://www.bajajfinserv.in/" class="header-anchor" target="_blank"><img class="head-logo-market"
              style="height: 3rem" alt="bflMarktesLogo" src="assets/img/svg/Bajaj_Finserv_Digital_Logo_Reverse.png"></a>
        </div>
        <div class="page-heading-txt" [ngClass]="bflJourney ? 'align-spc':''">
          <div class="insurance-head"> {{VehicleType === 'FWGI' ? 'Private Car' : VehicleType ===
            'TWGI'
            ?
            'Two Wheeler':VehicleType === 'TXGI' ? 'Taxi' : VehicleType === 'CVGI' ?'Commercial Vehicle' :''}}
            Insurance</div>
        </div>
      </div>
      <app-toggle-switch [showToggle]="!bflJourney" class="toggle-switch"></app-toggle-switch>
    </div>
    <div class="d-flex justify-content-between align-item-center"
      *ngIf="pageHeaderTxt != 'home' && pageHeaderTxt != 'editvehicle'">
      <div *ngIf="showBackArrow" class="page-back-arrow" (click)="goBack($event)">
        <svg class="page-back-arrow-icon" width="18px" height="12px" viewBox="0 0 31.151 20.776">
          <path fill="#fff"
            d="M19.16 11.649a1.414 1.414 0 0 1 .011 1.991l-6.579 6.59h25.039a1.407 1.407 0 0 1 0 2.813H12.6l6.579 6.59a1.424 1.424 0 0 1-.011 1.991 1.4 1.4 0 0 1-1.98-.011l-8.913-8.981a1.579 1.579 0 0 1-.292-.444 1.343 1.343 0 0 1-.108-.541 1.41 1.41 0 0 1 .4-.985l8.916-8.981a1.378 1.378 0 0 1 1.969-.032z"
            transform="translate(-7.875 -11.252)" />
        </svg>
        <span class="page-heading-txt" [ngClass]="bflJourney ? 'align-spc':''">{{pageHeaderTxt}}</span>
      </div>
      <!-- Below condition is added to fix back issue on click pageHeaderTxt -->
      <span *ngIf="!showBackArrow" class="page-heading-txt"
        [ngClass]="bflJourney ? 'align-spc':''">{{pageHeaderTxt}}</span>
      <div class="pull-right fullscreen-hide" *ngIf="stepNumber">
        <!-- <img class="progress-sec light-icon-display" [src]="stepNumber" alt="progressbar"> -->
        <div class="center hide-desktop-xm">
          <app-progress-circle [targetPercentage]="circleStagePercentage" [step]="stepNumber" [isMobile]="true">
          </app-progress-circle>
        </div>
      </div>
      <div class="help-button" *ngIf="showNeedHelp">
        <!-- This code is commented as we want to display drawer from need help in mobile as well,
          we are handling need help button visibility based on displayContent property now -->
        <!-- <div class="hide-mobile-xm"> -->
          <need-help [notify]="notifyObj" [displayNeedHelpText]="displayNeedHelpText" (click)="cleverTapPayload()" ></need-help>
        <!-- </div> -->
      </div>

    </div>
  </div>
</div>
